var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{staticClass:"ant-table-striped",attrs:{"size":"middle","columns":_vm.columns,"data-source":_vm.liveInfo,"rowClassName":(record, index) => (index % 2 === 1 ? 'table-striped' : null),"bordered":"","pagination":_vm.paginationObject}})
}
var staticRenderFns = []

export { render, staticRenderFns }